import { http } from '@/utils/request'
import type { PaginationParams, PaginationResult } from '@/api/types'

export interface ManualInfo {
    id: string
    manualName: string
    manualDesc: string
    manualSize: number
    manualPath: string
    category: number
    downloadCount: number
    tags: string
}

export interface ManualQueryParams extends PaginationParams {
    category?: number
    keyword?: string
}

export interface ManualListResponse {
    total: number
    rows: ManualInfo[]
    code: number
    msg: string
}

export interface ManualDetail {
    id: string
    manualName: string
    manualDesc: string
    manualSize: number
    manualPath: string
    category: number
    downloadCount: number
    tags: string
    createTime?: string
    updateTime?: string
}

export interface ManualCategory {
    id: number
    name: string
    count: number
}

export interface ManualUploadParams {
    file: File
    category: number
    manualName: string
    manualDesc?: string
    tags?: string
}

export interface ManualUpdateParams {
    id: string
    manualName?: string
    manualDesc?: string
    category?: number
    tags?: string
}

export interface ManualDeleteParams {
    id: string
}

export interface IncrementDownloadCountParams {
    id: string
}

export interface ManualStatsResponse {
    totalManuals: number
    totalDownloads: number
    categoryStats: ManualCategory[]
}

export interface ManualSearchParams {
    keyword?: string
    category?: number
    page?: number
    pageSize?: number
}

export interface ManualSearchResponse {
    total: number
    rows: ManualInfo[]
    code: number
    msg: string
}

export interface ManualListParams {
    page?: number
    pageSize?: number
    category?: number
    keyword?: string
}

export interface ManualListResult {
    total: number
    rows: ManualInfo[]
    code: number
    msg: string
}

export interface manualQueryParams {
    pageNum?: number
    pageSize?: number
    category?: number
    manualName?: string
}

export const manualApi = {
    getManualList: (params: manualQueryParams) =>
        http.get<ManualListResult>('/manual/list', params),

    getManualDetail: (id: string) =>
        http.get<ManualDetail>(`/manual/detail/${id}`),

    downloadManual: (id: string) =>
        http.get<Blob>(`/manual/download/${id}`, {}, { 
            responseType: 'blob',
            headers: { 'Content-Type': 'application/octet-stream' }
        }),

    uploadManual: (data: FormData) =>
        http.post<{ success: boolean; message?: string }>('/manual/upload', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }),

    updateManual: (params: ManualUpdateParams) =>
        http.put<{ success: boolean; message?: string }>('/manual/update', params),

    deleteManual: (params: ManualDeleteParams) =>
        http.delete<{ success: boolean; message?: string }>('/manual/delete', params),

    incrementDownloadCount: (params: IncrementDownloadCountParams) =>
        http.post<{ success: boolean }>('/manual/download/count', params),

    getManualStats: () =>
        http.get<ManualStatsResponse>('/manual/stats'),

    searchManuals: (params: ManualSearchParams) =>
        http.get<ManualSearchResponse>('/manual/search', params),

    getCategories: () =>
        http.get<ManualCategory[]>('/manual/categories')
}
